import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DailyProgressSummary = ({ className = '' }) => {
  const navigate = useNavigate();

  return (
    <div className={`bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl border border-border shadow-subtle ${className}`}>
      <div className="p-6">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Sparkles" size={24} className="text-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">Welcome to Cogito</h1>
            <p className="text-sm text-muted-foreground">
              Your daily snapshot will appear here once you start tracking habits and reviewing flashcards.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-card/60 border border-dashed border-border rounded-xl p-4 text-center space-y-2">
            <Icon name="Target" size={20} className="mx-auto text-primary" />
            <p className="text-sm font-medium text-foreground">Daily habits</p>
            <p className="text-xs text-muted-foreground">Create your first habit to see progress here.</p>
            <Button variant="outline" size="sm" className="w-full" onClick={() => navigate('/habits')}>
              Add habit
            </Button>
          </div>

          <div className="bg-card/60 border border-dashed border-border rounded-xl p-4 text-center space-y-2">
            <Icon name="Brain" size={20} className="mx-auto text-accent" />
            <p className="text-sm font-medium text-foreground">Flashcard decks</p>
            <p className="text-xs text-muted-foreground">Build a deck to start spaced repetition reviews.</p>
            <Button variant="outline" size="sm" className="w-full" onClick={() => navigate('/flashcards')}>
              Create deck
            </Button>
          </div>

          <div className="bg-card/60 border border-dashed border-border rounded-xl p-4 text-center space-y-2">
            <Icon name="TrendingUp" size={20} className="mx-auto text-success" />
            <p className="text-sm font-medium text-foreground">Track your wins</p>
            <p className="text-xs text-muted-foreground">Log activity to unlock daily summaries and trends.</p>
            <Button variant="outline" size="sm" className="w-full" onClick={() => navigate('/progress')}>
              View progress
            </Button>
          </div>
        </div>

        <div className="rounded-xl border border-dashed border-border p-6 bg-card/40">
          <h2 className="text-sm font-semibold text-foreground mb-2">How to get started</h2>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Add a daily habit you want to track.</li>
            <li>• Import or create a flashcard deck to review.</li>
            <li>• Come back after your first session to see insights here.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DailyProgressSummary;